<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style>
html,
body {
  margin: 0px !important;
  padding: 0px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
